import React, { useEffect } from "react";
import EnrollmentSummary from "./enrollment-summary";
import { sunboundPayProxy } from '@proxies';
import { useSpinnerContext } from '@contexts';
import { useLocation, useNavigate } from "react-router-dom";
import { helpers, Constants } from "@shared";
import { useFormSubmission } from "@hooks";
import { StatusCodes } from "http-status-codes";

const StepEnrollmentSummary = () => {

    const location = useLocation(), navigate = useNavigate();
    const { setSpinnerShow } = useSpinnerContext();
    const { setFormState, clearFormState, hasFormError, formError } = useFormSubmission();
    const {
        state: {
            invoice,
            invoicePayors,
            idProductType,
            account
        }
    } = location;
    const {
        idAccount,
        idPayor: idCurrentPayor,
        accountPreferences: { dueDay: preferenceDueDay }
    } = account;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const patchPayors = invoicePayors.map(p => {
        let { dueDay } = p;
        const { idPayor } = p;
        if (idPayor === idCurrentPayor)
            dueDay = preferenceDueDay;

        return { ...p, dueDay };
    });

    const done = async () => {
        setSpinnerShow(true);
        try {
            clearFormState();
            await sunboundPayProxy.enrollInvoice(idAccount, invoice.idInvoice, idProductType, patchPayors);
            helpers.navigateNext(location, navigate);
        } catch (error) {
            console.error(error);
            if (error.response?.status >= StatusCodes.BAD_REQUEST && error.response?.status < StatusCodes.INTERNAL_SERVER_ERROR)
                setFormState(error.response?.data.message);
            else
                setFormState(Constants.Errors.INTERNAL_ERROR);
        }
        setSpinnerShow(false);
    };

    const modify = () => {
        helpers.navigateTo(`/guarantor/invoice/payors`, location, navigate);
    };

    return (
        <EnrollmentSummary enrollment={patchPayors} done={done} modify={modify} invoice={invoice} error={{ hasFormError, formError }} idProductType={idProductType} account={account} />
    );
};

export default StepEnrollmentSummary;
